import * as React from "react";
import { GatsbyBrowser } from "gatsby";
import DefaultLayout, {
  IDefaultLayoutProps,
} from "../../src/layout/DefaultLayout/DefaultLayout";
import { parsePreviewDisplayMainNavigationFromLocationSearch } from "../../src/utils/widgetPreviewDisplayMainNavigationQuery";

export default (({ element, props }) => {
  const { pageContext, location } = props;
  const pageIntl: any = pageContext?.pageIntl || {};

  const search = typeof location?.search === "string" ? location.search : "";

  const pageTemplate: "Category" | string =
    (pageContext?.pageTemplate as string) ||
    (pageIntl?.pageTemplate as string) ||
    "";
  const isWidgetPage = pageTemplate === "Widget";

  const isPreview = new URLSearchParams(search).get("preview") === "true";

  const fromPageContext =
    (pageContext as { display_main_navigation?: boolean } | undefined)
      ?.display_main_navigation !== false;

  const fromPreviewUrl = parsePreviewDisplayMainNavigationFromLocationSearch({
    search,
    isPreview,
  });

  const displayMainNavigation =
    isWidgetPage &&
    fromPreviewUrl !== undefined
      ? fromPreviewUrl
      : fromPageContext;

  let wrapper: IDefaultLayoutProps["wrapper"];
  if (pageTemplate === "Category") {
    wrapper = "listing";
  }
  if (pageTemplate === "Home") {
    wrapper = "home";
  }
  if (pageTemplate === "StoreLocator") {
    wrapper = "store-locator";
  }

  // international page layout
  if (pageIntl?.layout === "empty") {
    return <>{element}</>;
  }
  return (
    <DefaultLayout
      wrapper={wrapper}
      widgetPageNavigation={
        isWidgetPage ? { isWidgetPage, displayMainNavigation } : undefined
      }
    >
      {element}
    </DefaultLayout>
  );
}) as GatsbyBrowser["wrapPageElement"];
